"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "la-thuile": {
    "346a5e73": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "skipSearch": false
    }],
    "arly": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "03442290": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "skipSearch": false
    }],
    "bathieu": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c332f427": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "skipSearch": false
    }],
    "buic": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a89a22f1": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "skipSearch": false
    }],
    "entreves": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "12b26965": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "skipSearch": false
    }],
    "grande-golette": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7826e7e2": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "skipSearch": false
    }],
    "la-joux": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9e5b27cd": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "skipSearch": false
    }],
    "les-suches": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b6c4c157": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "skipSearch": false
    }],
    "moulin": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "be340e6e": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "skipSearch": false
    }],
    "pera-cara": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ff19f156": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "skipSearch": false
    }],
    "petite-golette": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ee985ffc": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "skipSearch": false
    }],
    "petosan": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "db3951b3": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "skipSearch": false
    }],
    "piccolo-san-bernardo": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1a62c2cb": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "skipSearch": false
    }],
    "pont-serrand": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3dab9649": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "skipSearch": false
    }],
    "preyllon": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "186750ca": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "skipSearch": false
    }],
    "thovex": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "190ac39e": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "skipSearch": false
    }],
    "villaret": [{
      "hkey": "c40e5910",
      "slug": "la-thuile",
      "name": "La Thuile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;